export default __webpack_public_path__ + "static/media/cassia.74fbc943.png";